import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentError: null,
  hasError: false,
};

const errorSlice = createSlice({
  name: 'error',
  initialState,
  reducers: {
    setError: (state, action) => {
      state.currentError = action.payload;
      state.hasError = true;
    },
    clearError: (state) => {
      state.currentError = null;
      state.hasError = false;
    },
  },
});

export const { setError, clearError } = errorSlice.actions;

// Selectors
export const selectCurrentError = (state) => state.error.currentError;
export const selectHasError = (state) => state.error.hasError;

export default errorSlice.reducer;